module.exports = __webpack_public_path__ + "media/images/pizza-slice-2848aba767730b3143f09193a8d618de.png";